import { LoanStatusExternal, MetricMerchantView } from '@nemuru-eng/js-api-client';

import { MerchantScoreCardMetrics } from '@/components/modules/Metrics/shared/components/TopMerchants/types/MerchantScoreCardMetrics';
import { MetricAnalyzer } from '@/components/modules/Metrics/shared/entities/MetricAnalyzer';
import { TimeInterval } from '@/components/modules/Metrics/shared/entities/TimeInterval';

export class MerchantMetricAnalyzer {
  constructor(public readonly timeInterval: TimeInterval, public readonly metricViews?: MetricMerchantView[]) {}

  public scoreCardMetrics(loanStatusExternal: LoanStatusExternal): MerchantScoreCardMetrics[] {
    if (!this.metricViews) return [];

    const filteredMetricViews = this.metricViews.map((metricView) => {
      return {
        ...metricView,
        metrics: metricView.metrics.filter((metric) => metric.loanStatusExternal === loanStatusExternal),
      };
    });

    const scoreCardMetrics: MerchantScoreCardMetrics[] = [];

    filteredMetricViews.forEach((metricView) => {
      const metricsAccumulatedValues = new MetricAnalyzer(metricView).metricAnalyzerBaseMetrics(this.timeInterval);

      scoreCardMetrics.push({
        merchantId: metricView.merchantId,
        businessName: metricView.businessName,
        ...metricsAccumulatedValues,
      });
    });

    return scoreCardMetrics
      .sort((a, b) => (b.totalPrincipalAmount.current > a.totalPrincipalAmount.current ? 1 : -1))
      .slice(0, 5);
  }
}
